/**
 * 申し込みステップ
 */
export const Step = {
  new: [
    {
      name: 'form-product-input',
      desc: '商品のご入力'
    },
    {
      name: 'form-product-confirm',
      desc: '商品のご確認'
    },
    {
      name: 'form-sms',
      desc: 'SMS認証'
    },
    {
      name: 'form-user-input',
      desc: '個人情報のご入力'
    },
    {
      name: 'form-sigin',
      desc: '署名'
    },
    {
      name: 'form-upload',
      desc: '写真登録'
    },
    {
      name: 'form-pdf-issue',
      desc: 'PDF発行'
    },
    {
      name: 'form-done',
      desc: '申込完了'
    }
  ],
  add: [
    {
      name: 'form-product-input',
      desc: '商品のご入力'
    },
    {
      name: 'form-product-confirm',
      desc: '商品のご確認'
    },
    {
      name: 'form-sms',
      desc: 'SMS認証'
    },
    {
      name: 'form-user-input',
      desc: '個人情報のご入力'
    },
    {
      name: 'form-sigin',
      desc: '署名'
    },
    {
      name: 'form-upload',
      desc: '写真登録'
    },
    {
      name: 'form-pdf-issue',
      desc: 'PDF発行'
    },
    {
      name: 'form-done',
      desc: '申込完了'
    }
  ],
  change: [
    {
      name: 'form-product-input',
      desc: '商品のご入力'
    },
    {
      name: 'form-product-confirm',
      desc: '商品のご確認'
    },
    {
      name: 'form-upload',
      desc: '写真登録'
    },
    {
      name: 'form-pdf-issue',
      desc: 'PDF発行'
    },
    {
      name: 'form-done',
      desc: '申込完了'
    }
  ]
}
